import { Box } from '../../../foundation/Box/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '../../../foundation/Typography/styled.js';

function ListItemText(props) {
  var primary = props.primary,
    secondary = props.secondary;
  return /*#__PURE__*/jsxs(Box, {
    flexDirection: "column",
    gap: "xs",
    children: [primary && /*#__PURE__*/jsx(Typography, {
      $appearance: "300",
      $fontSize: "medium",
      $lineHeight: "neutralized",
      children: primary
    }), secondary && /*#__PURE__*/jsx(Typography, {
      $appearance: "100",
      $fontSize: "small",
      $lineHeight: "neutralized",
      children: secondary
    })]
  });
}

export { ListItemText };
